import { auth } from '@/firebase';
const URL = 'https://faas-nyc1-2ef2e6cc.doserverless.co/api/v1/web/fn-12f47b02-5e16-417c-b4e1-1566a1d5fe44/v1/class';

class Class {
    static async get(token=null) {
        const response = await fetch(`${URL}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
            },
        });

        console.log('Class.get response:', response);
        return response;
    }

    static async post(body, token=null) {
        const authToken = token || await auth.currentUser.getIdToken();
        const { icon, ...rest } = body;

        const headers = { 'Authorization': `Bearer ${authToken}` };

        if (icon instanceof File) {
            const requestBody = new FormData();
            requestBody.append('data', JSON.stringify(rest));
            requestBody.append('icon', icon, icon.name);
            return fetch(`${URL}`, { method: 'POST', headers, body: requestBody });
        }

        const jsonPayload = { ...rest };
        if (typeof icon === 'string' && icon.trim()) {
            jsonPayload.icon = icon.trim();
        }
        headers['Content-Type'] = 'application/json';
        return fetch(`${URL}`, { method: 'POST', headers, body: JSON.stringify(jsonPayload) });
    }

    static async put(body, id='', token=null) {
        const authToken = token || await auth.currentUser.getIdToken();
        const { icon, ...rest } = body;

        const headers = { 'Authorization': `Bearer ${authToken}` };

        if (icon instanceof File) {
            const requestBody = new FormData();
            requestBody.append('data', JSON.stringify(rest));
            requestBody.append('icon', icon, icon.name);
            return fetch(`${URL}/${id}`, { method: 'PUT', headers, body: requestBody });
        }

        const jsonPayload = { ...rest };
        if (typeof icon === 'string' && icon.trim()) {
            jsonPayload.icon = icon.trim();
        }
        headers['Content-Type'] = 'application/json';
        return fetch(`${URL}/${id}`, { method: 'PUT', headers, body: JSON.stringify(jsonPayload) });
    }

    static async delete(id='', token=null) {
        const response = await fetch(`${URL}/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`
            },
        });

        return response;
    }
}

export default Class;